import React, { Component } from 'react';
import HelperGenerics from '../../helpers/HelperGenerics';

class DocIntegrationSections extends Component {

    render() {
        return (
            <React.Fragment>
                <ul>
                    {this.props.sections.map((line, index) => (
                        <React.Fragment key={index}>
                            {this.renderOccurence(line)}
                        </React.Fragment>
                    ))}
                </ul>
            </React.Fragment>
        )
    }

    renderOccurence(line) {
        return (
            <li>
                {HelperGenerics.renderLink(null, line.key,line.text)}
                {line.children && line.children.length > 0 && <DocIntegrationSections sections={line.children} />}
            </li>
        );

    }
}

export default (DocIntegrationSections);
